import { render, staticRenderFns } from "./CancelTicket.vue?vue&type=template&id=5b905ed4"
import script from "./CancelTicket.vue?vue&type=script&lang=js"
export * from "./CancelTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports